import { Tween, Easing } from '@tweenjs/tween.js';
import { COMPONENTS, EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import { formatCurrencyValue, getCurrencySymbol } from '../helper/currencies';
import { TextMetrics } from 'pixi.js';
// import QuestData from "./helper/getQuestData";
import HELPERS from '../../lib/globals/helpers/Helpers';
import { QuestPromptView } from '../../view/quest/QuestPromptView';
import AnimateEntrance from '../helper/animate';

const events = [
	EVENTS.REEL_FINISHED,
	EVENTS.ERROR_MSG,
	EVENTS.BONUS_BUY,
	EVENTS.BET_PLACED,
	EVENTS.MODAL,
	EVENTS.WIN_HIGHLIGHT,
	EVENTS.QUEST_END
];

class QuestStatusBarController {
	constructor(vc, conf) {
		this.config = conf;
		this.vc = vc;
		this.toggleEventListeners(true);
		AnimateEntrance(this.vc);
		this.total = GameConfigs.quest_current ? GameConfigs.quest_current.win : 0;
		this.win_text = 0;
		this.win_modal = false;
		if (GameConfigs.quest_current) {
			this.leftSpins =
				GameConfigs.quest_current.prize.count -
				GameConfigs.quest_current.claimed;
		} else {
			this.leftSpins = GameConfigs.quest_claim.item.prize.count;
		}
		this.currency = getCurrencySymbol(GameConfigs.auth.balance.currency);
		this.updateWin(this.total);
		this.init();
	}

	toggleEventListeners(add) {
		events.forEach((event) =>
			window[add ? 'addEventListener' : 'removeEventListener'](
				event,
				this,
				false
			)
		);
	}

	init() {
		this.vc.bg.texts.FREE_SPIN_LEFT_AMOUNT.text = this.leftSpins;
		this.setWin(this.total);
		let type = GameConfigs.quest_claim.item.prize.type;
		if (type === 'wild_respin') {
			this.vc.bg.texts.FREE_SPIN_LEFT.text = 'WILD SPINS LEFT';
		}
		if (type === 'bet_discount') {
			this.vc.bg.texts.FREE_SPIN_LEFT.text = 'BETS LEFT';
		}
		if (type === 'win_multiplier') {
			this.vc.bg.texts.FREE_SPIN_LEFT.text = 'SPINS LEFT';
		}
		const FREE_SPIN_LEFT = TextMetrics.measureText(
			this.vc.bg.texts.FREE_SPIN_LEFT.text,
			this.vc.bg.texts.FREE_SPIN_LEFT.style
		);
		this.vc.bg.texts.FREE_SPIN_LEFT_AMOUNT.position.x =
			this.vc.bg.texts.FREE_SPIN_LEFT.position.x + FREE_SPIN_LEFT.width + 10;
	}

	handleEvent(object) {
		switch (object.type) {
			case EVENTS.REEL_FINISHED:
				this.reelFinished(object);
				break;
			case EVENTS.ERROR_MSG:
				this.toggleEventListeners(false);
				break;
			case EVENTS.QUEST_END:
				this.toggleEventListeners(false);
				break;
			case EVENTS.WIN_HIGHLIGHT:
				if (
					!object.detail.open &&
					GameConfigs.quest_claim.leftBets === 0 &&
					GameConfigs.quest_is_active
				) {
					this.status = 'completed';
					this.showTotalWin();
				}
				break;
			case EVENTS.BONUS_BUY:
				if (object.detail.bonus) {
					this.toggleEventListeners(false);
				}
				break;
			case EVENTS.BET_PLACED:
				if (object.detail.placed) {
					if (
						GameConfigs.quest_claim.activated_item ===
						GameConfigs.quest_claim.pending_item
					) {
						this.leftSpins--;
						this.vc.bg.texts.FREE_SPIN_LEFT_AMOUNT.text = this.leftSpins;
						GameConfigs.quest_claim = {
							...GameConfigs.quest_claim,
							leftBets: this.leftSpins
						};
					}
				}
				break;
			default:
				break;
		}
	}

	reelFinished() {
		this.total = GameConfigs.quest_current.win;
		this.updateWin(this.total);
		if (GameConfigs.quest_is_active && GameConfigs.quest_claim.leftBets === 0) {
			HELPERS.disableAllButtons(true);
			this.resetQuest();
			if (HELPERS.getWinLevels().length > 0) return;
			this.showTotalWin();
		}
	}

	resetQuest() {
		if (GameConfigs.autospin.isAutoOn) {
			HELPERS.dispatchCustomEvent(EVENTS.AUTO_STARTED, {
				numOfBets: GameConfigs.autospin.numOfBets,
				isAutoOn: false,
				leftBets: 0,
				pause: false
			});
		}
		GameConfigs.quest_claim = {
			...GameConfigs.quest_claim,
			activated_item: 0
		};
	}
	showTotalWin() {
		if (GameConfigs.uiComponent[COMPONENTS.QUEST_PROMPT] === undefined) {
			HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: 'quest_prompt' });
			GameConfigs.uiComponent.addView(QuestPromptView);
		}
		this.toggleEventListeners(false);
	}

	setWin(win) {
		this.vc.bg.texts.FREE_SPIN_WIN_AMOUNT.text = formatCurrencyValue(
			win,
			this.currency
		);
	}

	updateWin(win) {
		this.tweener = new Tween(this)
			.to({ win_text: win }, 500)
			.easing(Easing.Linear.None)
			.onUpdate(() => {
				this.setWin(this.win_text);
			})
			.start();
	}
}
export default QuestStatusBarController;
